var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotNetDc65Faf2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_dotnet"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.33464 24.9993C3.77666 24.9993 4.20059 25.1749 4.51315 25.4875C4.82571 25.8001 5.0013 26.224 5.0013 26.666C5.0013 27.108 4.82571 27.532 4.51315 27.8445C4.20059 28.1571 3.77666 28.3327 3.33464 28.3327C2.89261 28.3327 2.46868 28.1571 2.15612 27.8445C1.84356 27.532 1.66797 27.108 1.66797 26.666C1.66797 26.224 1.84356 25.8001 2.15612 25.4875C2.46868 25.1749 2.89261 24.9993 3.33464 24.9993ZM35.0013 28.3327H31.668V14.9993H28.3346V11.666H38.3346V14.9993H35.0013V28.3327ZM26.668 11.666V14.9993H23.3346V18.3327H26.668V21.666H23.3346V24.9993H26.668V28.3327H20.0013V11.666H26.668ZM18.3346 11.666V28.3327H15.0013L10.0013 18.3327V28.3327H6.66797V11.666H10.0013L15.0013 21.666V11.666H18.3346Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotNetDc65Faf2);
export default __webpack_public_path__ + "static/media/dotNet-dc65faf2.324080091874ed169f4656449d92856b.svg";
export { ForwardRef as ReactComponent };